<template>
  <div
    class="content-scroll-inner"
    :class="{
      'flow-text': flowText,
      'flex-height': flex,
      flex: flex,
      'flex-col': flex
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ContentScrollInner",
  props: ["flowText", "flex"]
};
</script>
